import { ACTIONS } from "../../common/constants";

const winbackDataReducer = function (state = false, action) {
  switch (action.type) {
    case ACTIONS.SET_WINBACK_UPGRADE_DATA:
      return action.data;
    default:
      return state;
  }
};

export default winbackDataReducer;
